'use client';

import { useState, useEffect } from 'react';

function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === 'undefined') return initialValue;
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error('Error reading localStorage key:', key, error);
      return initialValue;
    }
  });

  const setValue = (value) => {
    return new Promise((resolve, reject) => {
      try {
        setStoredValue(value);
        if (typeof window !== 'undefined') {
          window.localStorage.setItem(key, JSON.stringify(value));
        }
        resolve(); // Resolve the promise when successfully stored
      } catch (error) {
        console.error('Error setting localStorage key:', key, error);
        reject(error); // Reject the promise on error
      }
    });
  };

  return [storedValue, setValue];
}

export default useLocalStorage;

// 'use client';

// import { useState, useEffect } from 'react';

// function useSessionStorage(key, initialValue) {
//   const [storedValue, setStoredValue] = useState(() => {
//     if (typeof window === 'undefined') return initialValue;
//     try {
//       const item = window.sessionStorage.getItem(key);
//       return item ? JSON.parse(item) : initialValue;
//     } catch (error) {
//       console.error('Error reading sessionStorage key:', key, error);
//       return initialValue;
//     }
//   });


//   const setValue = (value) => {
//     return new Promise((resolve, reject) => {
//       try {
//         setStoredValue(value);
//         if (typeof window !== 'undefined') {
//           window.sessionStorage.setItem(key, JSON.stringify(value));
//         }
//         resolve(); // Resolve the promise when successfully stored
//       } catch (error) {
//         console.error('Error setting sessionStorage key:', key, error);
//         reject(error); // Reject the promise on error
//       }
//     });
//   };

//   return [storedValue, setValue];
// }

// export default useSessionStorage;